import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_UserSelfDetail',
  name: 'CDS_VF_UserSelfDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'ユーザ情報編集',
      controller: 'CDS_CTR_UserDetail',
    },
    guardRules: [user],
  },
};
